import { css } from '@compiled/react';
import { Heading } from '@atlassian/learning-components';
import { Link } from 'react-resource-router';
import { token } from '@atlaskit/tokens';
import Padlock from '../../../assets/images/padlock_Light mode_spot.svg';

const PrivateProfile = () => {
  const handleGoBack = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    window.history.back();
  };
  return (
    <div css={containerStyles} data-testid="private-profile-container">
      <img
        css={padlockStyles}
        data-testid="private-profile-image"
        src={Padlock}
        alt="Padlock Icon"
      />
      <Heading level={4} data-testid="private-profile-message">
        {'This profile is private.'}
      </Heading>
      <div css={headingLinkSpacer}></div>
      <Link
        css={linkStyles}
        href="#"
        onClick={handleGoBack}
        data-testid="private-profile-back-link"
      >
        {'Go back'}
      </Link>
    </div>
  );
};

export default PrivateProfile;

const containerStyles = css({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: token('space.600'),
  textAlign: 'center',
});

const padlockStyles = css({
  width: '160px',
  height: '160px',
  marginBottom: token('space.300'),
});

const headingLinkSpacer = css({
  marginTop: token('space.200'),
});

const linkStyles = css({
  color: token('color.text.brand'),
  fontFamily: token('font.family.brand.body'),
  fontSize: token('font.size.200'),
  fontStyle: 'normal',
  fontWeight: token('font.weight.semibold'),
  lineHeight: '20px',
  cursor: 'pointer',
});
